// ##TODO, Add it later once we implement lazy data fetching

export function useClearQueryBuilderEqlCache() {
  // const apolloClient = useApolloClient();
  // function clearCache() {
  //   const queriesToClear = [
  //     'listQueryBuilderGroups',
  //     'listEQLFields',
  //     'listEQLFieldValues',
  //   ];
  //   queriesToClear.forEach((queryName) => {
  //     apolloClient.cache.evict({ fieldName: queryName });
  //   });
  //   apolloClient.cache.gc();
  // }
  // useEffect(() => {
  //   return clearCache;
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
}
